import type { TestimonialCardProps } from "@/components/TestimonialCard/types/TestimonialCardProps";

export const testimonials: TestimonialCardProps[] = [
  {
    name: "Jonas Júnior Santiago Piona",
    company: "Objetiva Soluções",
    testimonial:
      "A RT Soluções tem sido uma parceira estratégica, trazendo aos nossos clientes a tranquilidade de uma gestão tributária segura e eficiente para seus produtos.",
    photo: "/jonas-junior-santiago.png",
    local: "Aracruz - ES",
  },
  {
    name: "Andressa Costa da Silva Cardoso",
    company: "Acentue Acessória Confabil",
    testimonial:
      "A RT Soluções tem sido uma parceira fundamental para o nosso escritório. O trabalho de recuperação de créditos junto aos nossos clientes e a manutenção dos cadastros de produtos têm trazido uma gestão muito mais eficiente, com impacto direto e positivo no caixa das empresas que atendemos. Uma parceria de confiança e excelentes resultados!",
    photo: "/andressa-costa-da-silva.png",
    local: "Linhares - ES",
  },
  {
    name: "Eudes Rocha",
    company: "JR Ferreira Auto Peças e Mecânica",
    testimonial:
      "Foi muito interessante o trabalho de redução de impostos feito na minha empresa, ao longo de 12 meses vamos ter uma economia muito grande que vai ser uma grande diferença, só tenho que agradecer a RT.",
    photo: "eudes-rocha.png",
    local: "São Gabriel da Palha - ES",
  },
  {
    name: "Sérgio Augusto Vieira",
    company: "Contador e Proprietário da Avanço Contabilidade",
    testimonial:
      "A parceria com a RT Soluções tem sido extremamente positiva para a Avanço Contabilidade e para nossos clientes. A empresa demonstra excelência e eficiência na recuperação de créditos tributários e na auditoria fiscal e tributária, sempre com profissionalismo, segurança e comprometimento. Os resultados alcançados comprovam a qualidade do trabalho realizado, trazendo benefícios concretos e fortalecendo a gestão contábil e tributária de nossos clientes e parceiros.",
    photo: "sergio_augusto_vieira.png",
    local: "Linhares - ES",
  },
  {
    name: "Lailton Gomes",
    company: "Proprietário da Loja Belo Cosméticos",
    testimonial:
      "Foi realizado o serviço de restituição na minha empresa e tive uma experiência extremamente positiva. Consegui recuperar valores pagos a mais, o que trouxe um grande alívio financeiro e mostrou, na prática, como esse benefício faz diferença no dia a dia. É uma excelente oportunidade para organizar as contas e aproveitar um retorno que muitas vezes nem imaginamos ter direito. Estou muito satisfeito com o resultado e recomendo a todos que ainda não fizeram, pois o processo é simples, seguro e gera um retorno real para a empresa. Parabéns à Restituir Soluções Tributárias pelo excelente trabalho!",
    photo: "lailton.png",
    local: "Linhares - ES",
  },
];
